import {
  DOCUMENT_STATUSES,
  type DocumentStatus,
  STORED_KINDS,
  type StoredKind,
} from '@glory/documents/domain';

/** Хранилище живёт в адресе: фильтры, поиск и открытая карточка — ссылкой можно поделиться. */
export interface DocumentsSearch {
  /** Открытая в панели карточка. */
  readonly doc?: string | undefined;
  readonly kind?: StoredKind | undefined;
  readonly status?: DocumentStatus | undefined;
  readonly client?: string | undefined;
  readonly deal?: string | undefined;
  readonly employee?: string | undefined;
  readonly q?: string | undefined;
  readonly from?: string | undefined;
  readonly to?: string | undefined;
  /** Показать архив вместо действующих. */
  readonly archived?: boolean | undefined;
  /** Открыть «Загрузить документ» — команда ⌘K и кнопка. */
  readonly upload?: boolean | undefined;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;
const DATE = /^\d{4}-\d{2}-\d{2}$/;
const date = (value: unknown): string | undefined =>
  typeof value === 'string' && DATE.test(value) ? value : undefined;
const flag = (value: unknown): true | undefined => (value === true || value === 'true' ? true : undefined);

export function parseDocumentsSearch(search: Record<string, unknown>): DocumentsSearch {
  return {
    doc: text(search.doc),
    kind: STORED_KINDS.find((kind) => kind === search.kind),
    status: DOCUMENT_STATUSES.find((status) => status === search.status),
    client: text(search.client),
    deal: text(search.deal),
    employee: text(search.employee),
    q: text(search.q),
    from: date(search.from),
    to: date(search.to),
    archived: flag(search.archived),
    upload: flag(search.upload),
  };
}

/** Есть ли фильтры, кроме открытой карточки: пустое состояние говорит «под фильтры ничего не подходит». */
export const hasFilters = (search: DocumentsSearch): boolean =>
  [
    search.kind,
    search.status,
    search.client,
    search.deal,
    search.employee,
    search.q,
    search.from,
    search.to,
  ].some((value) => value !== undefined) || search.archived === true;
